module.exports = __webpack_public_path__ + "img/0x947950bcc74888a40ffa2593c5798f11fc9124c4.27e3f017.png";